import { Card, Form, Table } from "react-bootstrap";

const GLXRPT = ({ output }) => {

    const downloadDocumentFile = () => {
        const anchor = document.createElement("a");
        anchor.href = output?.url;
        anchor.rel = "noopener noreferrer";
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    };
    return (
        <div>
            <Card className="mb-3 shadow-sm border-0 position-relative"
            >
                <Card.Body>
                    <div className="d-block">
                        <Form.Label><b>File Name:</b> {output?.name}</Form.Label><br />
                        <Form.Label><b>File Type:</b> .{output?.type}</Form.Label><br />
                        <Form.Label><b>File Size:</b> {output?.sizeMB}</Form.Label><br />
                        <Form.Label><b>File Location:</b> {output?.path}</Form.Label>
                    </div>
                    <div className="text-end w-100">
                        <button onClick={downloadDocumentFile} className="updateProfile">DownLoad Report</button>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default GLXRPT;
